import NavigationBarControl from '../../../lib/ui/NavigationBarControl'

export default class Start {
  constructor(element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'PRIM',
      leftHandButtons: [
        {
          onclick: () => {
            window.PRIM.navigate('/new/')
          },
          icon: '\ue0cf'
        },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        }],
      contextMenu: [
        {
          onclick: () => {
            window.PRIM.navigate('/about/')
          },
          icon: '\ue091',
          label: 'Over PRIM'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/changecredentials/')
          },
          icon: '\ue04b',
          label: 'Wachtwoord wijzigen'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/reportpeople/')
          },
          icon: '\ue052',
          label: 'Personen rapportage'
        },        
        /*{
          onclick: () => {
            window.PRIM.navigate('/import/')
          },
          icon: '\ue126',
          label: 'Gegevens importeren'
        },*/
        {
          onclick: () => {
            window.PRIM.navigate('/export/')
          },
          icon: '\ue065',
          label: 'Gegevens exporteren'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let button = document.createElement('button')
    button.innerHTML = 'Zoeken'
    button.onclick = () => {
      window.PRIM.navigate('/search/')
    }

    div.appendChild(button)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/Start.js